import { render, staticRenderFns } from "./TermsAndConditionsImprimBook.vue?vue&type=template&id=f4ef2826&scoped=true&"
import script from "./TermsAndConditionsImprimBook.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsImprimBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ef2826",
  null
  
)

export default component.exports